export default __webpack_public_path__ + "static/media/sell.d272e3e9.svg";